import { render, staticRenderFns } from "./FileHeader.vue?vue&type=template&id=54131a1b"
import script from "./FileHeader.vue?vue&type=script&lang=js"
export * from "./FileHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports